import { text, integer, index } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'
import { connectorInstances } from './connectors-instances'

// ============================================================================
// connectors_subscriptions — Event-bus subscriptions from other modules
//
// When `chat` wants to receive `message.received` events from every
// `messaging`-capable instance, it registers one row per (instance, event).
// Dispatcher reads rows where active=1 and fans out via handler_ref.
// ============================================================================
export const connectorSubscriptions = defineTable(
  'connectors',
  'subscriptions',
  {
    id: text('id').primaryKey(),
    instanceId: text('instance_id')
      .notNull()
      .references(() => connectorInstances.id, { onDelete: 'cascade' }),
    moduleId: text('module_id').notNull(),
    capability: text('capability').notNull(),
    eventName: text('event_name').notNull(),
    handlerRef: text('handler_ref').notNull(),
    active: integer('active').notNull().default(1),
    createdAt: text('created_at').notNull(),
    createdBy: text('created_by'),
    updatedAt: text('updated_at').notNull(),
    updatedBy: text('updated_by'),
  },
  (table) => [
    index('connectors_subscriptions_instance_cap_active_idx').on(
      table.instanceId,
      table.capability,
      table.active,
    ),
    index('connectors_subscriptions_module_id_idx').on(table.moduleId),
  ],
)

export type ConnectorSubscription = typeof connectorSubscriptions.$inferSelect
export type NewConnectorSubscription = typeof connectorSubscriptions.$inferInsert
